import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import { useSelector, useDispatch } from "react-redux";
import {
    hideAlert,
    selectAlertId,
    selectOpen,
    selectSeverity,
    selectMessage,
} from "src/redux/slices/AlertSlice";

const Alert = ({ duration }) => {
    const id = useSelector(selectAlertId);
    const open = useSelector(selectOpen);
    const severity = useSelector(selectSeverity);
    const message = useSelector(selectMessage);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(hideAlert());
    };

    const autoHideDuration =
        duration != null
            ? duration
            : severity === "error" || severity === "warning"
              ? 6000
              : 3500;

    return (
        <Snackbar
            key={id}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={open}
            onClose={handleClose}
            autoHideDuration={autoHideDuration}
            resumeHideDuration={Math.floor(autoHideDuration * 0.6)}
        >
            <MuiAlert
                onClose={handleClose}
                severity={severity}
                sx={{ width: "100%" }}
            >
                {message}
            </MuiAlert>
        </Snackbar>
    );
};

export default Alert;
